import React from 'react';

import { withStyles } from 'tss-react/mui';
import { Button, Grid, } from '@mui/material';
import { DateField } from '@mui/x-date-pickers/DateField';

import BarsEventosGovBr from './DashboardGraphs/BarsEventosGovBr';
import PieAcessos from './DashboardGraphs/PieAcessos';
import PieAceiteTermo from './DashboardGraphs/PieAceiteTermo';
import PieDownloads from './DashboardGraphs/PieDownloads';
import LineAcessos from './DashboardGraphs/LineAcessos';
import LineUploads from './DashboardGraphs/LineUpload';
import PieNivelGov from './DashboardGraphs/PieNivelGov';
import PieFeedback from './DashboardGraphs/PieFeedBack copy';

import { userService } from './services/user_functions';

const useStyles = (theme, props) => ({
  main: {
      marginTop: theme.spacing(0),
  },
  typo: {
      marginTop: theme.spacing(1),
      //align: "right", 
      //não funciona align: 'justify',
  },
  button: {
    margin: '10px',
  },
})


const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];
const SEVERITY_COLORS = [ '#0088FE','#00C49F', '#FFBB28', '#FF8042'];



class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: null,
      endDate: null,
      rawData: [],
      filteredData: [],
      hospitalAccessPieChartData: [],
      familyAccessPieChartData: [],
      hospitalDownloadPieChartData: [],
      familyDownloadPieChartData: [],
      usersPieChartData: [],
      hospitalAccessLineChartData: [],
      familyAccessLineChartData: [],
      uploadLineChartData: [],
      familyBarChartData: [],
      hospitalAceptTermsPieData: [],
      familyAceptTermsPieData: [],
      familyLevelPieChartData: [],
      familyFeedbackPieChartData: [],

    };
  }


  componentDidMount() {
    this.update_charts()

  }

  get_linedata_uploads = () =>{
    userService.get_linedata("uploads", this.state.startDate, this.state.endDate)
    .then(r => {this.setState({uploadLineChartData: r.data})})
    .catch(e =>{})
  };

  get_linedata_access = () => {
    userService.get_linedata("hospitalaccess", this.state.startDate, this.state.endDate)
    .then(r => {this.setState({hospitalAccessLineChartData: r.data}) })
    .catch(e =>{
      if (e.response) {
        if (e.response.status === 422) {
          alert("Não foi possível processar a data")
        } } })
    userService.get_linedata("familyaccess", this.state.startDate, this.state.endDate)
    .then(r => {this.setState({familyAccessLineChartData: r.data}) })
    .catch(e =>{})
  };

  get_piedata_access= () => {
    userService.get_piedata("hospitalaccess", this.state.startDate, this.state.endDate)
    .then(r => {this.setState({hospitalAccessPieChartData: r.data})})
    .catch(e =>{})
    userService.get_piedata("familyaccess", this.state.startDate, this.state.endDate)
    .then(r => {this.setState({familyAccessPieChartData: r.data})})
    .catch(e =>{})
    userService.get_piedata("familylevel", this.state.startDate, this.state.endDate)
    .then(r => {this.setState({familyLevelPieChartData: r.data})})
    .catch(e =>{})
  };

  get_piedata_feedback=()=>{
    userService.get_piedata("familyfeedback", this.state.startDate, this.state.endDate)
    .then(r => { this.setState({familyFeedbackPieChartData: r.data})})
    .catch(e =>{})
  }

  get_piedata_downloads= ()=>{
    userService.get_piedata("hospitaldownloads", this.state.startDate, this.state.endDate)
      .then(r => {
        this.setState({hospitalDownloadPieChartData: r.data})})
      .catch(e =>{})
      userService.get_piedata("familydownloads", this.state.startDate, this.state.endDate)
      .then(r => {this.setState({familyDownloadPieChartData: r.data})})
      .catch(e =>{})
  };

  get_piedata_accept_terms=()=>{
    userService.get_piedata("hospitalterms", this.state.startDate, this.state.endDate)
    .then(r=>{
      this.setState({hospitalAceptTermsPieData: r.data})})
    .catch(e =>{})
    userService.get_piedata("familyterms", this.state.startDate, this.state.endDate)
    .then(r=>{
      this.setState({familyAceptTermsPieData: r.data})})
    .catch(e =>{})
  }

  get_bardata_family=()=>{
    userService.get_bardata("family")
    .then(r=>{
      const data = r.data.map((v) => {
        return {
          event_code:v.event_code,
          description:v.description,
          count:parseInt(v.count),
          severity:parseInt(v.severity)
        }})
      this.setState({familyBarChartData: data});} )
    .catch(e =>{})
}


  update_charts=()=>{
    this.get_piedata_access()
    this.get_piedata_downloads()
    this.get_linedata_access()
    this.get_linedata_uploads()
    this.get_bardata_family()
    this.get_piedata_accept_terms()
    this.get_piedata_feedback()
  }



  handleDateChange = (e) => {
    const { name, value } = e.target;
    this.setState(
      { [name]: value },
      this.applyFilter
    );
  };

  applyFilter = () => {
    const { startDate, endDate, rawData } = this.state;

    const filtered = rawData.filter((item) => {
      const itemDate = item.date;
      return (
        (!startDate || itemDate >= startDate) &&
        (!endDate || itemDate <= endDate)
      );
    });

    this.setState({ filteredData: filtered });
  };

  handleCleanFilter = () =>{
    this.setState({startDate: null, endDate: null},
      ()=>{this.update_charts()}
    );
  }

  countByType = (type) => {
    return this.state.filteredData.filter(item => item.type === type).length;
  };


  render() {
    const { startDate, endDate } = this.state;
    const { classes } = this.props

    // TODO: trocar componentes div, h2 e input por componentes MUI
    return (
      <div style={{marginBottom: '30px'}}>
        <h2>Dashboard de Indicadores de Usabilidade do Sistema</h2>

        {/* Filtro de data */}
        <div style={{display: 'flex', alignItems: 'center'}}>
          <label>Data Inicial: </label>
          <DateField
            size='small'
            format='DD/MM/YYYY'
            value={this.state.startDate}
            onChange={(newValue)=>{this.setState({startDate: newValue})}}
          
          />
          <label style={{ marginLeft: 12 }}>Data Final: </label>
          <DateField
            size='small'
            format='DD/MM/YYYY'
            value={this.state.endDate}
            onChange={(newValue)=>{this.setState({endDate: newValue})}}
          
          />
        </div>
        <div style={{display: 'flex', justifyContent:'space-between', paddingLeft:'50px', paddingRight: '50px'}} >
          <Button variant='contained' color='primary' className={classes.button} onClick={this.update_charts}> Filtrar </Button>
          <Button variant='outlined' className={classes.button} onClick={this.handleCleanFilter}> Limpar Filtro </Button>
        </div>

        <div>
          <Grid container spacing={3}>
            <Grid size={4}> <PieAcessos data={this.state.hospitalAccessPieChartData} colors={COLORS} title={"Acesso de Pontos de Coleta"}/> </Grid>
            <Grid size={4}> <PieAcessos data={this.state.familyAccessPieChartData} colors={COLORS} title={"Acesso de Familias"}/> </Grid>
            <Grid size={4}> <PieNivelGov data={this.state.familyLevelPieChartData}/> </Grid>

            <Grid size={4}> <PieDownloads data={this.state.familyDownloadPieChartData} colors={COLORS} title={"Download de PDF por Familias"}/> </Grid>
            <Grid size={4}> <PieDownloads data={this.state.hospitalDownloadPieChartData} colors={COLORS} title={"Download de PDF por Pontos de Coleta"}/> </Grid>
            <Grid size={4}> <PieAceiteTermo data={this.state.hospitalAceptTermsPieData} title={"Aceite do Termo por Pontos de Coleta"} colors={COLORS}/> </Grid>
            <Grid size={4}> <PieAceiteTermo data={this.state.familyAceptTermsPieData} title={"Aceite do Termo por Familias"} colors={COLORS}/> </Grid>
            <Grid size={4}> <PieFeedback data={this.state.familyFeedbackPieChartData} title={"Experiencia do Usuário: Avaliação do sistema pela família"}/> </Grid>
            <Grid size={4}> </Grid>

            <Grid size={6}> <LineAcessos data={this.state.hospitalAccessLineChartData} colors={COLORS} title={"Acessos de Pontos de Coleta por dia"}/> </Grid>
            <Grid size={6}> <LineAcessos data={this.state.familyAccessLineChartData} colors={COLORS} title={"Acessos de Familia por dia"}/> </Grid>

            <Grid size={6}> <LineUploads data={this.state.uploadLineChartData} colors={COLORS} title={"Upload CSV e PDF"}/> </Grid>
            <Grid size={6}> <BarsEventosGovBr data={this.state.familyBarChartData} colors={SEVERITY_COLORS}/> </Grid>

          </Grid>
        </div>
      </div>
    );
  }
}

// export default Dashboard;

export default withStyles(Dashboard, useStyles);
